import './App.css';
import './style.css';
import Interface from './Interface';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="alien-pixelart.gif" className="alien" alt="Alien Pixelart Gif" />
        <h1 className="title">XenomorphWays</h1>
        <Interface />
      </header>
    </div>
  );
}

export default App;
